function calloutSectionSlider() {
    $('.callouts-swiper').each(function () {
            let $this = $(this),
                $swiperContainer = $this.find('.callout-slider'),
                sliderID = $this.attr('id'),
                isMobileSlider = $this.hasClass('has-mobile-slider'),
                isSingleSlider = $this.hasClass('single-slider');

            // Only initialize if swiper container exists
            if ($swiperContainer.length === 0) return;

            let swiperArgs = {
                direction: 'horizontal',
                autoplay: false,
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                grabCursor: true,
				observer: true,
                observeParents: true,
                watchSlidesProgress: true, // Required for managing focus on visible slides
                navigation: {
                    nextEl: $this.find('.swiper-button-next')[0],
                    prevEl: $this.find('.swiper-button-prev')[0],
                },
                pagination: {
                    el: $this.find('.swiper-pagination')[0],
                    clickable: true,
                    type: 'bullets',
                },
                // Add the event listener for accessibility
                on: {
                    init: function (swiper) {
                        updateTabIndex(swiper);
                    },
                    slideChange: function (swiper) {
                        updateTabIndex(swiper);
                    },
                },
            };

            // A helper function to manage tabindex based on your instructions
            const updateTabIndex = (swiperInstance) => {
                const focusableElementsSelector = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';

                // Set tabindex to -1 on all focusable elements in all slides first
                $(swiperInstance.slides).find(focusableElementsSelector).attr('tabindex', -1);

                // Get only the currently visible slides
                const visibleSlides = swiperInstance.slides.filter(slide => $(slide).hasClass('swiper-slide-visible'));

                // Enable tabbing only on focusable elements within the visible slides
                $(visibleSlides).find(focusableElementsSelector).removeAttr('tabindex');
            };

            if (isMobileSlider) {
                swiperArgs.breakpoints = {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                };
            }

            // Initialize Swiper
            const swiper = new Swiper($swiperContainer[0], swiperArgs);

            // Prevent Swiper from hijacking the Tab key.
            // This allows normal tabbing behavior without changing slides.
            const swiperContainerEl = $swiperContainer[0];
            swiperContainerEl.addEventListener('keydown', (event) => {
                // Check if the pressed key is the Tab key
                if (event.key === 'Tab') {
                    // Stop the event from propagating to Swiper's keyboard listener
                    event.stopPropagation();
                }
            }, true); // Use capture phase to catch the event before Swiper does.

            // Update swiper on window resize
            let resizeTimer;
            $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    if (swiper && !swiper.destroyed) {
                        // Update swiper to handle breakpoint changes
                        swiper.update();
                        swiper.updateSize();
                        swiper.updateSlides();
                        swiper.updateProgress();
                        swiper.updateSlidesClasses();

                        // Force recalculation of slides per view based on current breakpoint
                        const currentWidth = window.innerWidth;
                        let newSlidesPerView = 1; // Default mobile

                        if (isMobileSlider) {
                            if (currentWidth >= 1024) {
                                newSlidesPerView = 3;
                            } else if (currentWidth >= 768) {
                                newSlidesPerView = 2;
                            }
                        }

                        // Update params if they've changed
                        if (swiper.params.slidesPerView !== newSlidesPerView) {
                            swiper.params.slidesPerView = newSlidesPerView;
                            swiper.update();
                        }
                    }
                }, 250);
            });
        });
}
